import { createAsyncActionTypes } from '@mews/framework';
import { prefix } from './module';

export const AVAILABILITY_INTERVAL_REPORT_INIT = prefix('AVAILABILITY_INTERVAL_REPORT_INIT');
export const [
    AVAILABILITY_INTERVAL_REPORT_INIT_STARTED,
    AVAILABILITY_INTERVAL_REPORT_INIT_SUCCEEDED,
    AVAILABILITY_INTERVAL_REPORT_INIT_FAILED,
] = createAsyncActionTypes(AVAILABILITY_INTERVAL_REPORT_INIT);

export const AVAILABILITY_DATE_REPORT_INIT = prefix('AVAILABILITY_DATE_REPORT_INIT');
export const [
    AVAILABILITY_DATE_REPORT_INIT_STARTED,
    AVAILABILITY_DATE_REPORT_INIT_SUCCEEDED,
    AVAILABILITY_DATE_REPORT_INIT_FAILED,
] = createAsyncActionTypes(AVAILABILITY_DATE_REPORT_INIT);

export const AVAILABILITY_HEATMAP_INIT = prefix('AVAILABILITY_HEATMAP_INIT');
export const [
    AVAILABILITY_HEATMAP_INIT_STARTED,
    AVAILABILITY_HEATMAP_INIT_SUCCEEDED,
    AVAILABILITY_HEATMAP_INIT_FAILED,
] = createAsyncActionTypes(AVAILABILITY_HEATMAP_INIT);

export const AVAILABILITY_REPORT_FETCH = prefix('AVAILABILITY_REPORT_FETCH');
export const [
    AVAILABILITY_REPORT_FETCH_STARTED,
    AVAILABILITY_REPORT_FETCH_SUCCEEDED,
    AVAILABILITY_REPORT_FETCH_FAILED,
] = createAsyncActionTypes(AVAILABILITY_REPORT_FETCH);

export const TOTAL_DATA_SET = prefix('TOTAL_DATA_SET');
export const SERVICE_DATA_SET = prefix('SERVICE_DATA_SET');
export const SORTED_RESOURCE_CATEGORY_IDS_SET = prefix('SORTED_RESOURCE_CATEGORY_IDS_SET');
export const TIME_UNIT_BY_SERVICE_DATA_SET = prefix('TIME_UNIT_BY_SERVICE_DATA_SET');
export const TIME_UNIT_BY_RESOURCE_CATEGORY_DATA_SET = prefix('TIME_UNIT_BY_RESOURCE_CATEGORY_DATA_SET');
export const TIME_UNIT_TOTAL_DATA_SET = prefix('TIME_UNIT_TOTAL_DATA_SET');
export const RESOURCE_CATEGORY_TOTAL_DATA_SET = prefix('RESOURCE_CATEGORY_TOTAL_DATA_SET');
export const SERVICE_OVERBOOKING_LIMIT_DATA_SET = prefix('SERVICE_OVERBOOKING_LIMIT_DATA_SET');

export const INTERVAL_FILTER_VALUES_SET = prefix('INTERVAL_FILTER_VALUES_SET');
export const DATE_FILTER_VALUES_SET = prefix('DATE_FILTER_VALUES_SET');
export const HEATMAP_FILTER_VALUES_SET = prefix('HEATMAP_FILTER_VALUES_SET');
